import React, { useState } from "react";
import { FaBars, FaUserAlt, FaRegChartBar, FaUserGraduate } from "react-icons/fa";
import { TbLayoutGrid, TbReport } from "react-icons/tb";
import { MdQuiz } from "react-icons/md";
import { NavLink, useNavigate } from "react-router-dom";
import { homePathForRoles } from "./ProtectedRoute";
import "./Sidebar.css";

const Sidebar = ({ children }) => {
  const navigate = useNavigate();
  // Persist expanded/collapsed state so it survives navigation (each page mounts
  // its own Sidebar instance, which would otherwise reset to collapsed).
  const [isOpen, setIsOpen] = useState(
    () => localStorage.getItem("sidebarOpen") === "true"
  );
  const toggle = () => {
    const next = !isOpen;
    setIsOpen(next);
    localStorage.setItem("sidebarOpen", String(next));
  };
  const roleNames = (() => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      return user && user.roles ? user.roles.map((r) => r.roleName) : [];
    } catch (e) {
      return [];
    }
  })();
  const isSuperAdmin = roleNames.includes("SUPER_ADMIN");

  // Schools (ADMIN) manage students + assign classes only. Content management
  // (Classes/Quizzes) is SUPER_ADMIN-only, matching the backend authorization.
  const menuItem = [
    { path: "/adminDashboard", name: "Dashboard", icon: <FaRegChartBar /> },
    { path: "/adminProfile", name: "Profile", icon: <FaUserAlt /> },
    ...(isSuperAdmin
      ? [
          { path: "/adminCategories", name: "Classes", icon: <TbLayoutGrid /> },
          { path: "/adminQuizzes", name: "Quizzes", icon: <MdQuiz /> },
        ]
      : []),
    { path: "/adminStudents", name: "Students", icon: <FaUserGraduate /> },
    { path: "/adminallResult", name: "All Result", icon: <TbReport /> },
  ];

  if (isSuperAdmin) {
    menuItem.push({
      path: "/superadmin",
      name: "Super Admin",
      icon: <FaUserAlt />,
    });
  }
  return (
    <div
      className="container"
      style={{ display: "flex", width: "auto", margin: "0px", padding: "0px" }}
    >
      <div style={{ width: isOpen ? "12em" : "3em" }} className="sidebar">
        <div className="top_section">
          <h1
            style={{ display: isOpen ? "block" : "none", cursor: "pointer" }}
            className="logo"
            onClick={() => navigate(homePathForRoles(roleNames))}
            title="Go to dashboard"
          >
            Logo
          </h1>
          <div style={{ marginLeft: isOpen ? "50px" : "0px" }} className="bars">
            <FaBars onClick={toggle} />
          </div>
        </div>
        {menuItem.map((item, index) => (
          <NavLink
            to={item.path}
            key={index}
            className="sidemenulink"
            activeclassname="sidemenulink-active"
          >
            <div className="icon">{item.icon}</div>
            <div
              style={{ display: isOpen ? "block" : "none" }}
              className="link_text"
            >
              {item.name}
            </div>
          </NavLink>
        ))}
      </div>
      <main>{children}</main>
    </div>
  );
};

export default Sidebar;
